import { render, staticRenderFns } from "./amount.vue?vue&type=template&id=0076c6bd"
import script from "./amount.js?vue&type=script&lang=js&external"
export * from "./amount.js?vue&type=script&lang=js&external"
import style0 from "./amount.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports